import type { CSSProperties } from 'react'
import styled from 'styled-components'

import { Color } from '../../theme/color'

interface FlexProps {
  $gap?: number
}

export const AlignCenterItem = styled.div<FlexProps>`
  display: flex;
  align-items: center;
  ${({ $gap }) => ($gap ? `gap: ${$gap}px;` : '')}
`

export const JustifyCenterItem = styled.div<FlexProps>`
  display: flex;
  justify-content: center;
  ${({ $gap }) => ($gap ? `gap: ${$gap}px;` : '')}
`

export const CenterItem = styled.div<FlexProps & { $direction?: CSSProperties['flexDirection'] }>`
  display: flex;
  ${({ $direction }) => ($direction ? `flex-direction: ${$direction};` : '')}
  align-items: center;
  justify-content: center;
  ${({ $gap }) => ($gap ? `gap: ${$gap}px;` : '')}
`

export const RowBetween = styled(AlignCenterItem)`
  justify-content: space-between;
  ${({ $gap }) => ($gap ? `gap: ${$gap}px;` : '')}
`

export const ColumnItem = styled.div<FlexProps>`
  display: flex;
  flex-direction: column;
  ${({ $gap }) => ($gap ? `gap: ${$gap}px;` : '')}
`

export const List = styled.ul`
  display: flex;
  flex-direction: column;
  padding: 0 24px;
`

export const Item = styled.li<{ direction?: CSSProperties['flexDirection']; gap?: CSSProperties['gap'] }>`
  display: flex;
  flex-direction: ${({ direction }) => direction ?? 'column'};
  ${({ gap }) => (gap ? `gap: ${gap}px;` : '')}
  padding: 16px 0;
  border-bottom: 1px solid ${Color.line};
  list-style: none;
`

export const CenterWrap = styled(CenterItem)`
  width: 100%;
  height: 100%;
`
